import * as React from 'react';
import { commonColors } from '@workday/canvas-kit-react/tokens';
import { createSubcomponent, createElemPropsHook, composeHooks, } from '@workday/canvas-kit-react/common';
import { ListBox } from '@workday/canvas-kit-react/collection';
import { useReturnFocus, useFocusRedirect } from '@workday/canvas-kit-react/popup';
import { useMenuModel } from './useMenuModel';
export const useMenuList = composeHooks(createElemPropsHook(useMenuModel)(model => {
    return {
        role: 'menu',
        'aria-labelledby': model.state.id,
    };
}), useReturnFocus, useFocusRedirect);
export const MenuList = createSubcomponent('div')({
    displayName: 'Menu.List',
    modelHook: useMenuModel,
    elemPropsHook: useMenuList,
})(({ children, ...elemProps }, Element, model) => {
    return (React.createElement(ListBox, Object.assign({ as: Element, model: model, background: commonColors.background, borderRadius: "zero", padding: "zero", marginY: "xxs", gap: "zero", overflowY: "auto", flexDirection: model.state.orientation === 'vertical' ? 'column' : 'row' }, elemProps), children));
});
